module.exports = __webpack_public_path__ + "static/premios-1-EC-482318c30993d8fd6be19df3d8648991.webp";